// menucomponent/ErrorMessage.js
import React from "react";

export default function ErrorMessage({ message }) {
  return (
    <div className="error-message-container">
      <div className="error-message">
        <p>{message}</p>
      </div>
    </div>
  );
}